import ColorPalette from '../../../../colorpalette/ColorPalette';

/**
 * Escalas de severidade da assimetria craniana, usadas pela tabela do card e
 * pelo registro fotográfico. Funções puras: recebem a medição e devolvem
 * [percentual, { severity, color, textColor }].
 */

const UNKNOWN = { severity: "Desconhecido", color: ColorPalette.textLight, textColor: "white" };

const AP_BP_SCALE = [
    { min: 0, max: 65.00, severity: "Muito severa", color: ColorPalette.error, textColor: "white" },
    { min: 65.01, max: 68.00, severity: "Severa", color: ColorPalette.error, textColor: "white" },
    { min: 68.01, max: 71.00, severity: "Moderada", color: ColorPalette.warning, textColor: "white" },
    { min: 71.01, max: 75.00, severity: "Leve", color: ColorPalette.warningLight, textColor: ColorPalette.textDark },
    { min: 75.01, max: 90.00, severity: "Normal", color: ColorPalette.success, textColor: "white" },
    { min: 90.01, max: 94.00, severity: "Leve", color: ColorPalette.warningLight, textColor: ColorPalette.textDark },
    { min: 94.01, max: 98.00, severity: "Moderada", color: ColorPalette.warning, textColor: "white" },
    { min: 98.01, max: 102.00, severity: "Severa", color: ColorPalette.error, textColor: "white" },
    { min: 102.01, max: 9999999.99, severity: "Muito severa", color: ColorPalette.error, textColor: "white" },
];

const PLAGIOCEPHALY_SCALE = [
    { min: 0, max: 3.49, severity: "Normal", color: ColorPalette.success, textColor: "white" },
    { min: 3.5, max: 6.25, severity: "Leve", color: ColorPalette.warningLight, textColor: ColorPalette.textDark },
    { min: 6.26, max: 8.75, severity: "Moderada", color: ColorPalette.warning, textColor: "white" },
    { min: 8.76, max: 10.99, severity: "Severa", color: ColorPalette.error, textColor: "white" },
    { min: 11.00, max: 9999999.99, severity: "Muito severa", color: ColorPalette.error, textColor: "white" },
];

// Rounds to 2 decimals like the sheet does, so raw values never fall between two bands.
const findSeverity = (scale, percentage) => {
    const value = Number(Number(percentage).toFixed(2));
    if (!Number.isFinite(value)) return UNKNOWN;
    return scale.find(item => value >= item.min && value <= item.max) || UNKNOWN;
};

/**
 * Classifica um percentual já calculado (índice cefálico, BP/AP x 100) na escala AP/BP.
 */
export const classifyApBpPercentage = (percentage) => findSeverity(AP_BP_SCALE, percentage);

/**
 * Classifica um percentual já calculado (CVAI) na escala de plagiocefalia.
 */
export const classifyPlagiocephalyPercentage = (percentage) => findSeverity(PLAGIOCEPHALY_SCALE, percentage);

/**
 * Escala AP/BP (relação entre as medidas ântero-posterior e bi-parietal).
 */
export const getApBpSeverity = (entry) => {
    const ap = entry.ap;
    const bp = entry.bp;
    const normalizedDifference = bp / ap;
    const percentage = (normalizedDifference * 100).toFixed(2);

    return [percentage, classifyApBpPercentage(percentage)];
};

/**
 * Escala de plagiocefalia (CVAI), a partir das diagonais direita e esquerda.
 */
export const getPlagiocephalySeverity = (entry) => {
    const dd = entry.dd;
    const de = entry.de;

    const digMaior = dd > de ? dd : de;
    const digMenor = dd < de ? dd : de;

    const normalizedDifference = (digMaior - digMenor) / digMaior;
    const percentage = (normalizedDifference * 100).toFixed(2);

    return [percentage, classifyPlagiocephalyPercentage(percentage)];
};
